import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="mt-auto py-8 border-t border-xmas-gold/20 bg-white/50 backdrop-blur-sm">
      <div className="container mx-auto px-4 text-center">
        <p className="text-gray-600">
          &copy; 2026 Family Wishlist. All rights reserved.
        </p>
        <div className="mt-2 flex justify-center gap-4">
          <Link
            to="/about"
            className="text-xmas-green hover:text-xmas-red font-semibold transition-colors"
          >
            About
          </Link>
          <span className="text-gray-300">|</span>
          <Link
            to="/privacy-policy"
            className="text-xmas-green hover:text-xmas-red font-semibold transition-colors"
          >
            Privacy Policy
          </Link>
          <span className="text-gray-300">|</span>
          <Link
            to="/terms-of-service"
            className="text-xmas-green hover:text-xmas-red font-semibold transition-colors"
          >
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
